import * as React from 'react';
import Rings from './Rings';

export const ActivityRingsBase = ({ data, theme }) => {
  const { width } = data.config;
  const { height } = data.config;

  return (
    data && data.config && (
    <div style={styles.layout}>
      <div
        style={{ ...styles.container, width, height }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
        >
          <g transform={`translate(${width / 2},${height / 2})`}>
            <Rings
              pie={data.backPie}
              data={data.rings}
              theme={data.selectedTheme}
              back
              border
            />
            <Rings
              pie={data.backPie}
              data={data.rings}
              theme={data.selectedTheme}
              back
              border={false}
            />
            <Rings
              pie={data.frontPie}
              data={data.rings}
              theme={data.selectedTheme}
              back={false}
              border
            />
            <Rings
              pie={data.frontPie}
              data={data.rings}
              theme={data.selectedTheme}
              back={false}
              border={false}
            />
          </g>
        </svg>
      </div>
    </div>
    )
  );
};

// ActivityRingsBase.defaultProps = {
//   data: [],
//   theme: 'dark',
// };

const styles = {
  layout: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  container: {
    display: 'flex',
  },
};

const ActivityRings = React.memo(ActivityRingsBase);
export default ActivityRings;
